import LinkSection from './LinkSection'

export default LinkSection
